<div class="container">
  <c-button type="secondary" size="small" [iconOnly]="true" [icon]="closeIcon" (action)="close()" />
  <div>{{ 'common.language.title' | transloco }}</div>
  <div class="languages">
    @for (language of languages; track language) {
      <c-language-item
        [language]="language"
        variant="button"
        (click)="close(language)" />
    }
  </div>
</div>
